import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import SectionHead from "../SectionHead";
import { Reveal } from "../motion";

const IMGS = [
  "https://static.prod-images.emergentagent.com/jobs/60fe7cfd-579c-48af-b4a9-bdfd3f1b809e/images/355441be1ebd0b9963b26f9dda7afcf0727c4f6d557847b1146765cb214a0f3c.png",
  "https://static.prod-images.emergentagent.com/jobs/60fe7cfd-579c-48af-b4a9-bdfd3f1b809e/images/30e0299e9eca797787de29a57773e059f808d7056f12a2c880e2a7620659ff46.png",
  "https://static.prod-images.emergentagent.com/jobs/60fe7cfd-579c-48af-b4a9-bdfd3f1b809e/images/f1ce41d950ea9b7b0e0a636268d96e34369ec05d9cfb799269390c203763260d.png",
];

export default function FeaturedPrograms() {
  const { t } = useTranslation();
  return (
    <section className="surface-2 py-20 lg:py-28 border-y border-line" data-testid="home-featured">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-12">
        <SectionHead kicker={t("home.featured.kicker")} title={t("home.featured.title")} to="/programs" linkLabel={t("common.viewAll")} />
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {["p1", "p2", "p3"].map((k, i) => (
            <Reveal key={k} delay={i * 0.12}>
              <Link to="/programs" data-testid={`home-featured-${k}`} className="gxr-card group block overflow-hidden h-full">
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img src={IMGS[i]} alt={t(`programs.${k}.title`)} className="w-full h-full object-cover transition-transform duration-1000 ease-out group-hover:scale-[1.06]" />
                  <div className="absolute inset-0 bg-gradient-to-t from-forest-deep/70 via-transparent to-transparent" />
                  <span className="absolute bottom-4 ltr:left-4 rtl:right-4 pill !bg-white/90">{t(`home.featured.tag${i + 1}`)}</span>
                </div>
                <div className="p-6 lg:p-7">
                  <h3 className="font-display text-2xl leading-tight text-ink group-hover:text-forest transition-colors">{t(`programs.${k}.title`)}</h3>
                  <p className="mt-3 text-sm text-slate leading-relaxed line-clamp-3">{t(`programs.${k}.body`)}</p>
                  <div className="mt-5 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.14em] text-forest">
                    {t("common.explore")} <ArrowRight className="h-3.5 w-3.5 rtl:rotate-180 transition-transform group-hover:translate-x-1 rtl:group-hover:-translate-x-1" />
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
